import {FC, useState} from 'react';
import {useRecoilCallback} from 'recoil';

import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Stack from '@mui/system/Stack';
import Button from '@mui/material/Button';
import {EditContactPersonOfCompany} from './EditContactPersonOfCompany';
import {AddContactPersonOfCompany} from './AddContactPersonOfCompany';
import {DeleteContactPersonOfCompany} from './DeleteContactPersonOfCompany';
import {ContactPersonOfCompanyRow} from './ContactPersonOfCompanyRow';

import {
  contactPersonsOfCompanyState,
  currentContactPersonIdState,
  currentContactPersonState,
} from '../../../../../../store/contact-person/atoms';

import {IContactPerson} from '../../../../../../shared/types/person.types';

interface IContactPersonsOfCompanyBeingEdited {
  contactPersons: IContactPerson[];
}

const ContactPersonsOfCompanyBeingEdited: FC<IContactPersonsOfCompanyBeingEdited> = ({contactPersons}) => {
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const handleOpenEdit = useRecoilCallback(({snapshot, set}) => async (id: string) => {
    const currentContactPerson = (await snapshot.getPromise(contactPersonsOfCompanyState)).find(
      (i) => i.id === id,
    ) as IContactPerson;

    set(currentContactPersonState, currentContactPerson);
    set(currentContactPersonIdState, id);
    setOpenEdit(true);
  });

  const handleCloseEdit = () => setOpenEdit(false);

  const handleOpenAdd = () => setOpenAdd(true);

  const handleCloseAdd = () => setOpenAdd(false);

  const handleOpenDelete = useRecoilCallback(({snapshot, set}) => async (id: string) => {
    const currentContactPerson = (await snapshot.getPromise(contactPersonsOfCompanyState)).find(
      (i) => i.id === id,
    ) as IContactPerson;

    set(currentContactPersonState, currentContactPerson);
    set(currentContactPersonIdState, id);
    setOpenDelete(true);
  });

  const handleCloseDelete = () => setOpenDelete(false);

  return (
    <>
      <TableBody>
        {contactPersons.map((row) => (
          <ContactPersonOfCompanyRow
            key={row.id}
            row={row}
            handleEditClick={(e) => {
              e.stopPropagation();

              handleOpenEdit(row.id);
            }}
            handleDeleteClick={(e) => {
              e.stopPropagation();

              handleOpenDelete(row.id);
            }}
          />
        ))}
        <TableRow
          sx={{
            height: 53,
          }}
        >
          <TableCell colSpan={6}>
            <Stack direction="row" sx={{justifyContent: 'center'}}>
              <Button onClick={handleOpenAdd}>Добавить</Button>
            </Stack>
          </TableCell>
        </TableRow>
      </TableBody>
      {openAdd && <AddContactPersonOfCompany open={openAdd} handleClose={handleCloseAdd} />}
      {openEdit && <EditContactPersonOfCompany open={openEdit} handleClose={handleCloseEdit} />}
      {openDelete && <DeleteContactPersonOfCompany open={openDelete} handleClose={handleCloseDelete} />}
    </>
  );
};

export default ContactPersonsOfCompanyBeingEdited;
